// generated by the plop

import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';
import { ACCESS_TOKEN_KEY, PROGRESS_STATUSES } from 'symbols';
import { GpAuthService } from '../../services/gp-auth.service';
import {
  CheckConfirmCode,
  CheckResetPasswordCode,
  CheckTelegramBotExist,
  CheckTelegramBotExistFail,
  CheckTelegramBotExistSuccess,
  CheckUserExist,
  CheckUserExistFail,
  CheckUserExistSuccess,
  GetConfirmRegistrationCodeToTelegramBot,
  GetConfirmRegistrationCodeToTelegramBotFail,
  GetConfirmRegistrationCodeToTelegramBotSuccess,
  GetTelegramBotLink,
  InactivateAccount, InactivateAccountSuccess,
  Login,
  LoginFail,
  LoginSuccess,
  Logout,
  LogoutFail,
  LogoutSuccess,
  NewTelegramBotWs,
  Registration,
  RegistrationFail,
  RegistrationSuccess,
  ResetAuthState,
  ResetPassword,
  ResetPasswordFail,
  ResetPasswordSuccess
} from './gp-auth.actions';
import { AUTH_STATE_DEFAULT, AuthStateModel } from './gp-auth.model';

@State({ name: 'auth', defaults: AUTH_STATE_DEFAULT })
@Injectable()
export class GpAuthState implements NgxsOnInit {

  @Selector()
  static token(state: AuthStateModel): AuthStateModel['token'] {
    return state.token;
  }

  @Selector()
  static isAuthenticated(state: AuthStateModel): boolean {
    return !!state.token;
  }

  @Selector()
  static loginStatus(state: AuthStateModel): AuthStateModel['loginStatus'] {
    return state.loginStatus;
  }

  @Selector()
  static checkUserExistStatus(state: AuthStateModel): AuthStateModel['checkUserExistStatus'] {
    return state.checkUserExistStatus;
  }

  @Selector()
  static isUserExist(state: AuthStateModel): AuthStateModel['isUserExist'] {
    return state.isUserExist;
  }

  @Selector()
  static checkTelegramBotExistStatus(state: AuthStateModel): AuthStateModel['checkTelegramBotExistStatus'] {
    return state.checkTelegramBotExistStatus;
  }

  @Selector()
  static isTelegramBotExist(state: AuthStateModel): AuthStateModel['isTelegramBotExist'] {
    return state.isTelegramBotExist;
  }

  @Selector()
  static sendConfirmCodeStatus(state: AuthStateModel): AuthStateModel['sendConfirmCodeStatus'] {
    return state.sendConfirmCodeStatus;
  }

  @Selector()
  static telegramBotLink(state: AuthStateModel): AuthStateModel['telegramBotLink'] {
    return state.telegramBotLink;
  }

  @Selector()
  static telegramBotListStatus(state: AuthStateModel): AuthStateModel['telegramBotListStatus'] {
    return state.telegramBotListStatus;
  }

  @Selector()
  static registrationToken(state: AuthStateModel): AuthStateModel['registrationToken'] {
    return state.registrationToken;
  }

  constructor(private authService: GpAuthService) {
  }

  ngxsOnInit(ctx: StateContext<AuthStateModel>): void {
    ctx.dispatch(new GetTelegramBotLink());
  }

  @Action(Login)
  login(ctx: StateContext<AuthStateModel>, { data }: Login): void {
    ctx.patchState({
      loginStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.authService.login(data).subscribe({
      next: res => ctx.dispatch(new LoginSuccess(res)),
      error: err => ctx.dispatch(new LoginFail(err))
    });
  }

  @Action(LoginSuccess)
  loginSuccess(ctx: StateContext<AuthStateModel>, { token }: LoginSuccess): void {
    this.authService.saveToken(token);
    ctx.patchState({
      loginStatus: PROGRESS_STATUSES.SUCCESS,
      token
    });
  }

  @Action(LoginFail)
  loginFail(ctx: StateContext<AuthStateModel>, { error }: LoginFail): void {
    ctx.patchState({
      loginStatus: PROGRESS_STATUSES.FAIL
    });
  }


// added actions by plop
  @Action(Logout)
  logout(ctx: StateContext<AuthStateModel>): void {
    this.authService.logout().subscribe({
      next: () => ctx.dispatch(new LogoutSuccess()),
      error: err => ctx.dispatch(new LogoutFail(err))
    });
  }

  @Action(LogoutSuccess)
  logoutSuccess(ctx: StateContext<AuthStateModel>): void {
    this.authService.clearToken();
    ctx.setState(AUTH_STATE_DEFAULT);
  }

  @Action(LogoutFail)
  logoutFail(ctx: StateContext<AuthStateModel>): void {
    this.authService.clearToken();
    ctx.setState(AUTH_STATE_DEFAULT);
  }


  @Action(Registration)
  registration(ctx: StateContext<AuthStateModel>, { data, token }: Registration): void {
    this.authService.registration(data, token).subscribe({
      next: user => ctx.dispatch(new RegistrationSuccess(user)),
      error: err => ctx.dispatch(new RegistrationFail(err))
    });
  }

  @Action(RegistrationSuccess)
  registrationSuccess(ctx: StateContext<AuthStateModel>, { data }: RegistrationSuccess): void {
  }

  @Action(RegistrationFail)
  registrationFail(ctx: StateContext<AuthStateModel>, { error }: RegistrationFail): void {
    console.error('Registration fail', error);
  }

  @Action(CheckUserExist)
  checkUserExist(ctx: StateContext<AuthStateModel>, { tel }: CheckUserExist): void {
    ctx.patchState({
      checkUserExistStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.authService.checkUserExist(tel).subscribe({
      next: isExist => ctx.dispatch(new CheckUserExistSuccess(isExist)),
      error: err => ctx.dispatch(new CheckUserExistFail(err))
    });
  }

  @Action(CheckUserExistSuccess)
  checkUserExistSuccess(ctx: StateContext<AuthStateModel>, { isExist }: CheckUserExistSuccess): void {
    ctx.patchState({
      checkUserExistStatus: PROGRESS_STATUSES.SUCCESS,
      isUserExist: isExist
    });
  }

  @Action(CheckUserExistFail)
  checkUserExistFail(ctx: StateContext<AuthStateModel>, { error }: CheckUserExistFail): void {
    ctx.patchState({
      checkUserExistStatus: PROGRESS_STATUSES.FAIL
    });
  }

  @Action(CheckTelegramBotExist)
  checkTelegramBotExist(ctx: StateContext<AuthStateModel>, { tel }: CheckTelegramBotExist): void {
    ctx.patchState({
      checkTelegramBotExistStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.authService.checkTelegramBotExist(tel).subscribe({
      next: isExist => ctx.dispatch(new CheckTelegramBotExistSuccess(isExist)),
      error: err => ctx.dispatch(new CheckTelegramBotExistFail(err))
    });
  }

  @Action(CheckTelegramBotExistSuccess)
  checkTelegramBotExistSuccess(ctx: StateContext<AuthStateModel>, { isExist }: CheckTelegramBotExistSuccess): void {
    ctx.patchState({
      checkTelegramBotExistStatus: PROGRESS_STATUSES.SUCCESS,
      isTelegramBotExist: isExist
    });
  }

  @Action(CheckTelegramBotExistFail)
  checkTelegramBotExistFail(ctx: StateContext<AuthStateModel>, { error }: CheckTelegramBotExistFail): void {
    ctx.patchState({
      checkTelegramBotExistStatus: PROGRESS_STATUSES.FAIL
    });
  }

  @Action(GetConfirmRegistrationCodeToTelegramBot)
  getConfirmCodeToTelegramBot(ctx: StateContext<AuthStateModel>, { tel }: GetConfirmRegistrationCodeToTelegramBot): void {
    ctx.patchState({
      sendConfirmCodeStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.authService.getConfirmCodeToTelegramBot(tel).subscribe({
      next: () => ctx.dispatch(new GetConfirmRegistrationCodeToTelegramBotSuccess()),
      error: err => ctx.dispatch(new CheckTelegramBotExistFail(err))
    });
  }

  @Action(GetConfirmRegistrationCodeToTelegramBotSuccess)
  getConfirmCodeToTelegramBotSuccess(ctx: StateContext<AuthStateModel>): void {
    ctx.patchState({
      sendConfirmCodeStatus: PROGRESS_STATUSES.SUCCESS
    });
  }

  @Action(GetConfirmRegistrationCodeToTelegramBotFail)
  getConfirmCodeToTelegramBotFail(ctx: StateContext<AuthStateModel>, { error }: CheckTelegramBotExistFail): void {
    ctx.patchState({
      checkTelegramBotExistStatus: PROGRESS_STATUSES.FAIL
    });
  }

  @Action(GetTelegramBotLink)
  getTelegramBotLink(ctx: StateContext<AuthStateModel>): void {
    this.authService.getTelegramBotLink().subscribe({
      next: link => ctx.patchState({ telegramBotLink: link }),
      error: err => console.error(err)
    });
  }

  @Action(NewTelegramBotWs)
  newTelegramBotWs(ctx: StateContext<AuthStateModel>, { payload }: NewTelegramBotWs): void {
    ctx.patchState({
      telegramBotListStatus: {
        ...ctx.getState().telegramBotListStatus,
        ...payload
      }
    });
  }

  @Action(CheckConfirmCode)
  checkConfirmCode(ctx: StateContext<AuthStateModel>, { data }: CheckConfirmCode): void {
    this.authService.checkRegistrationConfirmCode(data).subscribe({
      next: registrationToken => ctx.patchState({ registrationToken }),
      error: () => ctx.patchState({ registrationToken: null })
    });
  }

  @Action(ResetAuthState)
  resetAuthState(ctx: StateContext<AuthStateModel>): void {
    ctx.setState(AUTH_STATE_DEFAULT);
    localStorage.setItem(ACCESS_TOKEN_KEY, '');
  }


  @Action(CheckResetPasswordCode)
  checkResetPasswordCode(ctx: StateContext<AuthStateModel>, { data }: CheckResetPasswordCode) {
    this.authService.checkResetPasswordConfirmCode(data).subscribe({
      next: registrationToken => ctx.patchState({ registrationToken }),
      error: () => ctx.patchState({ registrationToken: null })
    });
  }

  @Action(ResetPassword)
  resetPassword(ctx: StateContext<AuthStateModel>, { data, token }: ResetPassword) {
    this.authService.resetPassword(data, token).subscribe({
      next: () => ctx.dispatch(new ResetPasswordSuccess()),
      error: err => ctx.dispatch(new ResetPasswordFail(err))
    });
  }

  @Action(InactivateAccount)
  inactivateAccount(ctx: StateContext<AuthStateModel>): void {
    this.authService.inactivateAccount().subscribe({
      next: () => ctx.dispatch(new InactivateAccountSuccess()),
      error: err => console.error('Error inactivating account:', err)
    });
  }
}


